import React from "react";

function NotFound() {
  return (
    <div className="w-full h-full flex items-center justify-center">
      <h2>NotFound</h2>
    </div>
  );
}

export default NotFound;
